import Yup from 'utils/yup'

export const defaultValues = {
  model: null,
}

export const validationSchema = Yup.object().shape({
  model: Yup.string().nullable().max(60, 'O modelo deve ter no máximo 60 caracteres'),
})
